module.exports = __webpack_public_path__ + "img/imgsierraa.74f57fb4.png";